import { render } from "./Login.vue?vue&type=template&id=35a1845c&scoped=true"
import script from "./Login.vue?vue&type=script&lang=ts"
export * from "./Login.vue?vue&type=script&lang=ts"

import "./Login.vue?vue&type=style&index=0&id=35a1845c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-35a1845c"

export default script